<template>
    <ion-select @ionChange="update(lineable, $event)" :value="selected" placeholder="No users" multiple="true">
        <ion-select-option :value="user.id" :key="user.id" v-for="user in users">
            {{ user.name }}
        </ion-select-option>
    </ion-select>
</template>

<script>
import {IonSelect, IonSelectOption} from '@ionic/vue';
import _ from "lodash";
import EventBus from "@/EventBus";
export default {
    name: "ShipmentStockTakeUserAssignment",
    components: {IonSelect, IonSelectOption},
    inject: ['$http', '$validationAlert'],
    props: ['lineable', 'update-payload', 'lineable-update-url', 'user-permission', 'users', 'users-property'],
    computed: {
        /**
         * This hack prevents the property 'lineable', which triggers a change when the parent
         * component is refreshed, from triggering the @ionChange event. So you end up making a
         * change in here, refreshing, then overwriting your original change.
         *
         * The real fix would be for this component to emit out the real values of the ion-select
         */
        selected() {
            /* eslint-disable */
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 250);
            /* eslint-enable */
            return _.map(this.lineable[this.usersProperty], 'id');
        }
    },
    data() {
        return {
            editable: false,
            locked: false
        }
    },
    methods: {
        update(lineable, event, callback) {
            if (this.locked) {
                return;
            }

            const users = _.filter(this.users, user => {
                return event.detail.value.indexOf(user.id) > -1;
            });
            EventBus().emitter.emit('loading', true);
            const payload = {...this.updatePayload, ...{users:users}};
            this.$http.put(this.lineableUpdateUrl, payload, {
                params: {include: 'pickers,checkers,packers'}
            }).then(() => {
                if (callback) {
                    callback.apply();
                }
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                EventBus().emitter.emit('loading', false);
            });
        },

    }
}
</script>

<style scoped>

</style>
